import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number, currency: string = 'COP'): string {
  const locale = currency === 'USD' ? 'en-US' : currency === 'MXN' ? 'es-MX' : 'es-CO'
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
    }).format(amount)
  } catch {
    return `$ ${amount.toLocaleString()}`
  }
}

export function formatDate(date: Date | string): string {
  let dateObj: Date
  if (typeof date === 'string') {
    let s = date.trim()
    // Normalize 'YYYY-MM-DD HH:MM:SS+00' -> 'YYYY-MM-DDTHH:MM:SS+00'
    if (s.includes(' ')) s = s.replace(' ', 'T')
    // If string has only a date (no time), add midday to avoid TZ shift issues
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) s = `${s}T12:00:00`
    dateObj = new Date(s)
  } else {
    dateObj = new Date(date)
  }
  if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) {
    return '--/--/----'
  }
  const dd = String(dateObj.getDate()).padStart(2, '0')
  const mm = String(dateObj.getMonth() + 1).padStart(2, '0')
  const yyyy = dateObj.getFullYear()
  return `${dd}/${mm}/${yyyy}`
}

export function formatMonthYear(date: Date | string): string {
  const dateObj = typeof date === 'string' ? new Date(date + 'T12:00:00') : date
  return new Intl.DateTimeFormat('es-CO', {
    year: 'numeric',
    month: 'long',
  }).format(dateObj)
}
